<template>
    <div class="shadow" @click="onClick" :style="{width:clientWidth+'px',height:clientHeight+'px'}">
        <div class="shadow-bg">
            <div class="shadow-bg-QRCode"></div>
            <div class="shadow-bg-close"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            clientWidth: document.documentElement.clientWidth,
            clientHeight: document.documentElement.clientHeight,
            closeImage: require("../assets/img/home/close.png"),
        }
    },
    mounted(){
        let self = this;
        window.onresize = function() {
            self.clientWidth = document.documentElement.clientWidth,
            self.clientHeight = document.documentElement.clientHeight;
        }
    },
    methods: {
        onClick() {
            this.$store.state.alertState.isShowQRCode = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.shadow {
    background-color: rgba($color: #000000, $alpha: 0.6);
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-size: contain;
    position: fixed;
    z-index: 9999;
    display: flex;
    top:0;
    &-bg {
        display: initial;
        &-QRCode {
            width: 260px;
            height: 260px;
            background: #FFFFFF;
            border-radius: 4px;
            background-image: url("../assets/img/home/QRCode.png");
            background-repeat: round;
        }
        &-close {
            width: 36px;
            height: 37px;
            margin: auto;
            margin-top: 20px;
            background-image: url("../assets/img/home/close.png");
            background-size: 100%;
        }
        &-hint {
            margin-top: 15px;
            font-size: 25px;
            color: #fff;
            text-align: center;
        }
    }
    
}
</style>